import { c as _c } from "react/compiler-runtime";
import { MiniChips } from "@website/ui/mini-chips";
import { dateFormat } from "@website/utils/date-format";
import { numberConvert } from "@website/utils/number-convert";
import { ReserveCommentAvatar } from "@website/widget/reserve-comment/reserve-comment-avavtar";
import bookingLogo from "@website/widget/reserve-comment/reserve-comment-header/assets/booking.svg";
import { ReserveCommentHeaderPropertiesType } from "@website/widget/reserve-comment/reserve-comment-header/reserve-comment-header.types";
import { ReserveCommentRating } from "@website/widget/reserve-comment/reserve-comment-rating";
import { useRouter } from "next/router";
export const ReserveCommentHeader = t0 => {
  const $ = _c(29);
  const {
    properties
  } = t0;
  const {
    userName,
    registeredDate,
    roomName,
    standNights,
    rate,
    source
  } = properties;
  const router = useRouter();
  let t1;
  if ($[0] !== rate) {
    t1 = <div className="block size-[40px] rounded-full border content-[''] xl:hidden"><ReserveCommentAvatar className="mx-auto ms-[7px] mt-[7px] size-[24px]" rate={rate} /></div>;
    $[0] = rate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== userName) {
    t2 = <div>{userName}</div>;
    $[2] = userName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== registeredDate) {
    t3 = dateFormat(registeredDate, {
      locale: "fa",
      template: "MMMM yyyy"
    });
    $[4] = registeredDate;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <span>{t3}</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== router || $[9] !== standNights) {
    t5 = standNights && <span className="px-1">{`(${numberConvert(standNights, {
        locale: router.locale
      })} شب)`}</span>;
    $[8] = router;
    $[9] = standNights;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="text-on-surface-medium-emphasis text-overline mt-1">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t6) {
    t7 = <div className="text-caption xl:text-subtitle-2 flex flex-auto flex-col gap-0">{t2}{t6}</div>;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== rate) {
    t8 = <span className="col-span-1 grid-flow-col lg:order-2"><ReserveCommentRating rate={rate} /></span>;
    $[17] = rate;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== roomName) {
    t9 = <div className="mx-0 basis-full md:ml-2 lg:order-1 lg:basis-auto xl:mt-0 lg:ltr:mr-2"><MiniChips size="medium" text={roomName} variant="accent" /></div>;
    $[19] = roomName;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== source) {
    t10 = source === "booking.com" && <MiniChips StartIcon={<img alt="booking" src={bookingLogo?.src} />} size="medium" text={"booking \u062B\u0628\u062A \u0634\u062F\u0647 \u062F\u0631"} variant="accent" />;
    $[21] = source;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t1 || $[24] !== t10 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t11 = <div className="flex flex-row flex-wrap items-center justify-between gap-2 xl:mb-0 xl:grow-0 xl:items-start xl:gap-0">{t1}{t7}{t8}{t9}{t10}</div>;
    $[23] = t1;
    $[24] = t10;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
};